import { resetPassword as sendResetEmail } from "@/auth/auth";
import { routes } from "@/constants/routes";
import { useTheme } from "@/theme/ThemeProvider";
import { AppButton } from "@/ui/components/AppButton";
import { ErrorText } from "@/ui/components/ErrorText";
import { FloatingLabelInput } from "@/ui/components/FloatingLabelInput";
import { LinkText } from "@/ui/components/LinkText";
import { useRouter } from "expo-router";
import { useState } from "react";
import { ScrollView, Text } from "react-native";

export default function ForgotPasswordScreen() {
  const { theme } = useTheme();
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const canSubmit = email.trim().length > 0 && !loading;

  const handleSubmit = async () => {
    if (!canSubmit) return;
    setError(null);
    setLoading(true);
    try {
      await sendResetEmail(email);
      setSent(true);
    } catch (e: unknown) {
      setError(e instanceof Error ? e.message : "E-Mail konnte nicht gesendet werden.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <ScrollView
      style={{ flex: 1, backgroundColor: theme.color.bg }}
      contentContainerStyle={{
        flexGrow: 1,
        justifyContent: "center",
        padding: 24,
        gap: 16,
        maxWidth: 400,
        alignSelf: "center",
        width: "100%",
        backgroundColor: theme.color.bg,
      }}
    >
      <Text style={{ color: theme.color.text, fontSize: theme.fontSize.title, fontWeight: "700" }}>
        Passwort vergessen
      </Text>
      <Text style={{ color: theme.color.muted, fontSize: theme.fontSize.body }}>
        Wir schicken einen Link. Das neue Passwort legst du erst fest, nachdem du den Link auf der
        nächsten Seite bestätigt hast.
      </Text>
      {sent ? (
        <Text style={{ color: theme.color.primary, fontWeight: "600" }}>
          Wenn ein Konto zu dieser Adresse existiert, ist die E-Mail unterwegs.
        </Text>
      ) : (
        <>
          <FloatingLabelInput
            label="E-Mail"
            value={email}
            onChangeText={setEmail}
            keyboardType="email-address"
            autoCapitalize="none"
            returnKeyType="send"
            onSubmitEditing={handleSubmit}
          />
          {error ? <ErrorText>{error}</ErrorText> : null}
          <AppButton onPress={handleSubmit} disabled={!canSubmit} loading={loading}>
            {loading ? "Wird gesendet…" : "Link senden"}
          </AppButton>
        </>
      )}
      <LinkText onPress={() => router.replace(routes.login)} color={theme.color.muted}>
        Zurück zum Login
      </LinkText>
    </ScrollView>
  );
}
